import { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_CONTENT } from "./defaults";

const ContentContext = createContext(DEFAULT_CONTENT);

const isPlainObject = (v) => v && typeof v === "object" && !Array.isArray(v);

const deepMerge = (base, override) => {
  if (!isPlainObject(base) || !isPlainObject(override)) {
    return override !== undefined ? override : base;
  }
  const out = { ...base };
  for (const key of Object.keys(override)) {
    out[key] = key in base ? deepMerge(base[key], override[key]) : override[key];
  }
  return out;
};

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => (r.ok ? r.json() : {}))
      .then((data) => setContent(deepMerge(DEFAULT_CONTENT, data.content || {})))
      .catch(() => {});
  }, []);

  return (
    <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
